import { isNormalUser } from "@/utils/roleStorage";
import { CircularProgress } from "@mui/material";
import React from "react";

export const TaleCircularProgress = ({
  role = "normal",
  colorOverride = null,
  ...props
}) => {
  return (
    <React.Fragment>
      <svg width={0} height={0}>
        <defs>
          <linearGradient id="taleGradient" x1="0%" y1="0%" x2="0%" y2="100%">
            <stop
              offset="0%"
              stopColor={isNormalUser() ? "#00BDA9" : "#F9BC33"}
            />
            <stop
              offset="100%"
              stopColor={isNormalUser() ? "#00C0FC" : "#FE346E"}
            />
          </linearGradient>
        </defs>
      </svg>
      <CircularProgress
        sx={{ "svg circle": { stroke: colorOverride || "url(#taleGradient)" } }}
        {...props}
      />
    </React.Fragment>
  );
};
